import { findComponentConfigPath } from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateFlowEditor/utils';
import {
  validateParentComponentConfig,
  validateTransitionComponentConfig,
} from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateScreenComponentEditor/component-validations';
import { ComponentValidationErrorsMap } from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateScreenComponentEditor/component-validations/types';
import { uiStepAllComponentConfigs } from 'dashboard/apps/InquiryTemplateEditor/utils/steps';
import {
  InquiryTemplateVersionStep,
  isUiStepConfig,
} from 'dashboard/models/inquiry-template-version';

export const getComponentConfigValidationErrors = ({
  steps,
}: {
  steps: InquiryTemplateVersionStep[];
}): ComponentValidationErrorsMap => {
  const stepComponentValidationErrors: ComponentValidationErrorsMap = {};

  for (const step of steps.filter(isUiStepConfig)) {
    for (const componentConfig of uiStepAllComponentConfigs(step)) {
      const componentPath = findComponentConfigPath(
        (c) => c.name === componentConfig.name,
        step.config.components,
      );
      if (componentPath == null) break;

      const errors = [
        ...validateTransitionComponentConfig({ componentConfig, step }),
        ...validateParentComponentConfig({ componentConfig, step }),
      ];

      // TODO (eric): re-enable blocking on-save after a couple weeks of warning-only
      // if (errors.length === 0 && enableLogicValidation) {
      //   errors = errors.concat(
      //     validateComponentConfigLogicRules({
      //       componentConfig,
      //       step,
      //       fieldSchema,
      //       workflowVersionMap,
      //     }),
      //   );
      // }

      if (errors.length) {
        /** for now, return when *any* errors are found since only the first is shown in the UI */
        stepComponentValidationErrors[`${componentPath.join('.')}`] = errors;
        break;
      }
    }
  }

  return stepComponentValidationErrors;
};
